import FooterCalloutRepository from "../FooterCalloutRepository"

export default class CompanyFooterCallout extends FooterCalloutRepository {
    static schemaId = "company_footerCallout"

    constructor() {
        super(CompanyFooterCallout.schemaId)
    }
}
